
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
    import {dictApi, manufactoryApi, roleApi, userApi} from "@/api/organization";
    import {draftApi} from "@/api/rules";
    import baseUrl, {imageUrl} from "@/constants";
    const {regionData} =require("@/js/region/region");
    import axios from "axios";

    @Component
    export default class UserData0 extends Vue {
        title = "个人基础信息";
        addform = {
            idCard: "",  //身份证号
            name: "",  //姓名
            formerName: "",    //曾用名
            gender: 0,    //性别
            birthday: "",    //出生日期
            ethnicity: "",    //民族
            phone: "",    //手机号码
            nativePlace: "",    //籍贯
            nativePlaceArr: "",    //籍贯
            birthPlace: "",    //出生地
            birthPlaceArr: "",    //出生地
            education: "",    //最高学历
            degree: "",    //最高学位
            politicalStatus: "",    //政治面貌
            admissionTime: "",    //入党（团、派别）日期
            workStartTime: "",    //参加工作日期
            engagedStartTime: "",    //从事计量工作开始日期
            avatar: "",  //头像
        } as any
        rules = {
            idCard: [{ required: true, message: '请输入身份证号', trigger: 'blur' }],
            name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        }
        dictTitle = {
            "C031": "ethnicity",  //民族
            "xl": "education",  //学历
            "xw": "degree",  //学位
            "C029": "politicalStatus",  //政治面貌
            "employee_category": "category",  //人员类别
            "jrbdwxs1": "enterForm",  //进入单位形式
            "rysf": "status",  //人员身份
            "xcsgz1": "workType",  //现在从事工作
            "xrzw": "post",  //现任行政职务
            "xrzj": "level",  //现行政职级
            "xrzg": "title",  //现技术职称资格
            "xpgw": "currentPosition",  //现聘职级
        } as any;
        dictList = {
            ethnicity: [],  //民族
            education: [],  //学历
            degree: [],  //学位
            politicalStatus: [],  //政治面貌
            category: [],  //人员类别
            enterForm: [],  //进入单位形式
            status: [],  //人员身份
            workType: [],  //现在从事工作
            post: [],  //现任行政职务
            level: [],  //现行政职级
            title: [],  //现技术职称资格
            currentPosition: [],  //现聘职级
        } as any
        baseUrl = baseUrl
        imageUrl = imageUrl
        headers = {Authorization:""}
        regionData = regionData
        roleArr = [];  //角色备选列表
        roleIds = [];  //选中的角色
        /**
         * 编辑的id
         * */
        @Prop() private id!: any;
        @Prop() private pageType!: any; //0添加  1编辑  2查看 3个人
        created() {
            if(this.id){
                this.init();
            }
        }
        init(){
            axios.all([
                    this.getDict("C031"),  //民族
                    this.getDict("xl"),
                    this.getDict("xw"),
                    this.getDict("C029"),
                    this.listRole(),
                ],
            ).then(axios.spread((acct,perms)=>{
                if(this.id != "0"){
                    this.loadDetail();
                }
            }))
        }
        loadDetail(){
            userApi.loadDetail({id: this.id}).then(r => {
                if (r.data.result === 0) {
                    const rData = r.data.data as any;
                    if(rData.userBaseInfo){
                        if(rData.userBaseInfo.nativePlace){
                            rData.userBaseInfo.nativePlaceArr = rData.userBaseInfo.nativePlace.split(",");
                        }
                        if(rData.userBaseInfo.birthPlace){
                            rData.userBaseInfo.birthPlaceArr = rData.userBaseInfo.birthPlace.split(",");
                        }
                        this.addform = rData.userBaseInfo;
                    }
                    if(rData.roleIds){
                        this.roleIds = rData.roleIds;
                    }else{
                        this.roleIds = [];
                    }
                }
            })
        }
        getDict(typeCode: string) {
            return dictApi.listDictItem({
                typeCode: typeCode
            }).then(r => {
                if (r.data.result === 0) {
                    const rData = r.data.data;
                    if(this.dictTitle[typeCode]){
                        const b = this.dictTitle[typeCode] as string;
                        this.dictList[b] = rData;
                        if(rData.length>0){
                            if(this.addform[b] !== undefined){
                                this.addform[b] = rData[0].dictValue
                            }
                        }
                    }
                }
            })
        }
        //获取角色
        listRole(){
            roleApi.list(0,undefined).then((r:any)=>{
                if(r.data.result === 0){
                    this.roleArr = r.data.data;
                }
            })
        }

    }
